enum NameEnum {
    MAIN = "Main",
    REJECTED_APPLICATION = "Rejected application",
    ACCEPTED_APPLICATION = "Accepted application",
    EXTERNAL_SITE_IN_LOKI = "External site in Loki",
    ACCESS_DENIED = "Access denied"
}

export default NameEnum;
